<div class="search_wrap">
    <div>
        <nz-tabset [nzSelectedIndex]="tabSelectedIndex" (nzSelectedIndexChange)="changeTab($event)">
            <nz-tab [nzTitle]="'VIN_NO'| translate">
                <ng-template nz-tab>
                    <!--Vin No.-->
                    <div #vinDiv class="rego_no flex-v-center" *ngIf="searchType === 'vin'">
                        <form [formGroup]="searchFormData" class="flex-v-center w100">
                            <nz-input-group [nzSuffix]="suffixTemplateInfo" class="bosch_input">
                                <input  nz-input type="text" (keyup.enter)="queryVehiclesByVin()"
                                    (focus)="search('vinNo')" formControlName="vinNo"
                                    [placeholder]="'SEARCH_BY_VIN_NUMBER' | translate" />
                                <ng-template #suffixTemplateInfo>
                                    <i class="search" (click)="queryVehiclesByVin()"></i>
                                </ng-template>
                            </nz-input-group>
                        </form>
                    </div>
                </ng-template>
            </nz-tab>
            <nz-tab [nzTitle]="'VEHICLE'| translate">
                <ng-template nz-tab>
                    <!--Vehicle-->
                    <div *ngIf="searchType === 'vehicle'">
                        <form [formGroup]="searchFormData" class="flex-v-center w-full">
                            <div class="rego_no flex-v-center w-full gap-x-4">
                                <span class="text-red  leading-6 h-[24px] inline-block">*</span>
                                <nz-select nzShowSearch [nzSuffixIcon]="suffixSearch" class="bosch-select w-[20%]"
                                    [nzPlaceHolder]="'BRAND'|translate" formControlName="manu"
                                    (ngModelChange)="queryVehicleModelSeries()">
                                    <nz-option *ngFor="let manu of manuList" [nzValue]="manu.manuId"
                                        [nzLabel]="manu.manuName">
                                    </nz-option>
                                </nz-select>
                                <span class="text-red leading-6 h-[24px] inline-block">*</span>
                                <nz-select nzShowSearch [nzSuffixIcon]="suffixSearch" class="bosch-select w-[18%]"
                                    [nzPlaceHolder]="'MODEL'|translate"  formControlName="model"
                                    (ngModelChange)="queryVehicleTypeSeries()">
                                    <nz-option *ngFor="let model of modelList" [nzValue]="model"
                                        [nzLabel]="getFormattedLabel(model)">
                                    </nz-option>
                                </nz-select>
                                <span class="text-red leading-6 h-[24px] inline-block">*</span>
                                <nz-select nzShowSearch [nzSuffixIcon]="suffixSearch" [nzPlaceHolder]="'TYPE'|translate"
                                    class="bosch-select w-[18%]" formControlName="type" (ngModelChange)="queryDisplacement()">
                                    <nz-option *ngFor="let type of typeList" [nzValue]="type.modelId"
                                        [nzLabel]="getFormattedTypeLabel(type)">
                                    </nz-option>
                                </nz-select>
                                <nz-select  [nzSuffixIcon]="suffixSearch" [nzPlaceHolder]="'YEAR'|translate"
                                    class="bosch-select w-[18%]" formControlName="year" (ngModelChange)="chooseVehicleType()" nzMode="multiple" [nzMaxTagCount]="1" [nzShowSearch]="false" nzAllowClear
                                    [nzShowArrow]="true">
                                    <nz-option *ngFor="let item of yearList" [nzValue]="item" [nzLabel]="item">
                                    </nz-option>
                                </nz-select>
                                <nz-select  [nzSuffixIcon]="suffixSearch"  [nzPlaceHolder]="'DISPLACEMENT'|translate"
                                    class="bosch-select w-[18%]" formControlName="displacement" (ngModelChange)="chooseVehicleType()" nzMode="multiple" [nzMaxTagCount]="1" [nzShowSearch]="false" nzAllowClear
                                    [nzShowArrow]="true">
                                    <nz-option *ngFor="let placement of displacementList" [nzValue]="placement"  [nzLabel]="placement">
                                    </nz-option>
                                </nz-select>
                                <div class="w-[10%] flex">
                                    <button nz-button nzType="text" class="clear flex-center"  (click)="clear()">
                                      <svg-icon [iconName]="'new/close-blue.svg'" [size]="20" ></svg-icon> {{"CLEAR" | translate}}
                                    </button>
                                  </div>
                                <ng-template #suffixSearch><i class="search-arrow"></i></ng-template>
                            </div>
                            <!-- <div class="rego_no flex-v-center ml10 w-[30%]" >
                                <nz-input-group [nzSuffix]="suffixTemplateInfo" class="bosch_input w-full">
                                    <input (blur)="onBlur()" nz-input type="text" 
                                        (keyup.enter)="linkageTargePage()" formControlName="vehicle"
                                        (focus)="search('vehicle')"
                                        [placeholder]="'SEARCH_DIRECTLY_BY_CAR_NAME'|translate" />
                                    <ng-template #suffixTemplateInfo>
                                        <i class="search" (click)="linkageTargePage()"></i>
                                    </ng-template>
                                </nz-input-group>
                            </div> -->
                        </form>
                    </div>
                </ng-template>
            </nz-tab>
            <nz-tab [nzTitle]="'PRODUCT'| translate">
                <ng-template nz-tab>
                    <!--Product-->
                    <div class="rego_no flex-v-center" *ngIf="searchType === 'product'">
                        <form [formGroup]="searchFormData" class="flex-v-center w100">
                            <nz-input-group [nzSuffix]="suffixTemplateInfo" class="bosch_input">
                                <input (blur)="onBlur()" nz-input type="text" formControlName="product"
                                    (keyup.enter)="queryArticleByArticles(searchFormData.get('product')?.value)"
                                    (focus)="search('product')" [placeholder]="'SEARCH_BY_MANY' | translate" />
                                <ng-template #suffixTemplateInfo>
                                    <i class="search"
                                        (click)="queryArticleByArticles(searchFormData.get('product')?.value)"></i>
                                </ng-template>
                            </nz-input-group>
                        </form>
                    </div>
                </ng-template>
            </nz-tab>

        </nz-tabset>
    </div>
</div>
<div class="search-results" #searchResult *ngIf="showResult" [ngClass]="searchType === 'vehicle'?'search-vehicle-results':''">
    <ul *ngIf="searchResults.length > 0 && isHistory">
        <li class="history"> {{ "SEARCH_HISTORY" | translate }}</li>
    </ul>
    <ul *ngIf="searchResults.length > 0 && searchType === 'rego'">
        <li *ngFor="let result of searchResults" (click)="queryVehicleModel(result)" [title]="result">{{ result}}</li>
    </ul>
    <ul *ngIf="searchResults.length > 0 && searchType === 'vin'">
        <li *ngFor="let result of searchResults" (click)="toggleSelection(result, $event)" 
        [title]="result?.carName"
        [ngClass]="{'selected': isSelected(result)}">{{
            result?.carName }}</li>
    </ul>
    <ul *ngIf="searchResults.length > 0 && searchType === 'vehicle'">
        <li *ngFor="let vehicle of searchResults" (click)="queryVehicleModel(vehicle)"
            [title]="vehicle?.linkageTargetId+' | '+vehicle?.mfrName+' '+vehicle?.vehicleModelSeriesName +' '+vehicle?.capacityLiters+' | '+vehicle?.beginYearMonth+' - '+  vehicle?.endYearMonth +' | '+vehicle?.kiloWattsFrom+' kw | '+vehicle?.horsePowerFrom +' HP | '+vehicle?.capacityCC +'cc'">
            {{ vehicle?.linkageTargetId }} | {{ vehicle?.mfrName }} {{ vehicle?.vehicleModelSeriesName }}
            {{vehicle?.capacityLiters}} | {{vehicle?.beginYearMonth}} - {{vehicle?.endYearMonth}} |
            {{vehicle?.kiloWattsFrom}} kw | {{vehicle?.horsePowerFrom}} HP | {{vehicle?.capacityCC}} cc</li>
    </ul>
    <ul *ngIf="searchResults.length > 0 && searchType === 'product'">
        <li *ngFor="let result of searchResults" (click)="queryVehicleModel(result)" [title]="result">{{ result }}</li>
    </ul>
    <ul *ngIf="searchResults.length == 0 && !isHistory">
        <li> {{'NO_RESULTS_FOUND' | translate}}</li>
    </ul>
</div>